export default "__VITE_ASSET__c4ce45ec__"